import { Component, Directive, OnInit, OnDestroy, ElementRef, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';

const OPEN_SIZE = 0.4;
type SidebarVisibilityState = 'open' | 'closed' | 'full';

const calculateWidth = (element: ElementRef): number => {
  const size = element.nativeElement.getBoundingClientRect();
  return Math.floor(size.width);
};

const getScaleFactor = (state: SidebarVisibilityState): number => {
  switch (state) {
    case 'open': return OPEN_SIZE;
    case 'full': return 1;

    default: return 0;
  }
}

const DRAWER_STATE = {
  OPEN: 'open',
  CLOSED: 'closed',
  FULL: 'full'
};

@Component({
  selector: 'idap-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  host: {
    class: 'sidebar-host'
    // '[@toggle]': 'collapsed'
  },
  animations: [trigger('toggle', [
    state('full', style({ transform: 'translateX(-100%)' })),
    state('open', style({ transform: `translateX(${-100 * 1}%)` })),
    state('closed', style({ transform: 'translateX(0)' })),
    transition('* <=> *', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
  ])]
})
export class SidebarComponent implements OnInit, OnDestroy {
  @Output() onToggle: EventEmitter<SidebarComponent> = new EventEmitter();

  collapsed: SidebarVisibilityState = 'open';
  states: SidebarVisibilityState[] = ['closed', 'open', 'full'];
  private stateIdx: number = this.states.indexOf(this.collapsed);
  private totalStates: number = this.states.length;

  constructor(private element: ElementRef) { }

  ngOnInit() { }

  toggle(offset: -1 | 1) {
    this.stateIdx = (this.stateIdx + offset) % this.totalStates;
    this.collapsed = this.states[this.stateIdx];
    this.onToggle.next(this);
  }

  ngOnDestroy() {
    this.onToggle.complete();
  }

  setWidth(width: number) {
    this.element.nativeElement.style.width = `${width}px`;
  }
}

@Directive({ selector: 'idap-sidebar-content' })
export class SidebarContentPlaceholder { }



// WEBPACK FOOTER //
// ./src/app/main/components/sidebar.component.ts